"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=erc1155.js.map